import React from 'react';
import classNames from 'classnames';

import HeaderContents from './header_contents.jsx';
import HeaderSocialLinks from './header_social_links.jsx';

import SiteViewerVersionComponentSelector
  from 'zoomforth_codesbane_viewer/component_lib/site_viewer_version_component_selector_container.jsx';

const HeaderWrapperUi_ViewerVersion1 = ({ tellRef, ...props })=>
  <div ref={tellRef} { ...props } />;

const HeaderWrapperUi_ViewerVersion2 = ({ tellRef, ...props })=>
  <header ref={tellRef} { ...props } />;

const HeaderWrapperUi = (props)=> (
  <SiteViewerVersionComponentSelector>
    <HeaderWrapperUi_ViewerVersion1 forSiteViewerVersion={1} { ...props } />
    <HeaderWrapperUi_ViewerVersion2 forSiteViewerVersion={2} { ...props } />
  </SiteViewerVersionComponentSelector>
);

const HeaderUi = ({
  children,
  isInPageSearchEnabled,
  pageTitle, 
  renderAsMobile, 
  secondaryLogoData,
  socialLinks, 
  shouldShowTitle, 
  shouldShowHeaderContents, 
  reallyShouldShowSocialLinks,
  tellRef, 
  shouldShowLanguageSelectorInHeader,
  appliedLanguages,
  currentLanguageIso,
  defaultLanguageIso,
  onLanguageChange,
  onHeaderLogoClick,
  onSearchStarterClick
})=> {
  return (
    <HeaderWrapperUi
      className={classNames(
        'header', 
        {
          'has-social-icons': reallyShouldShowSocialLinks,
          'mobile-header': !!renderAsMobile
        }
      )}
      style={{
        display: shouldShowHeaderContents ? null : 'none'
      }}
      tellRef={tellRef}
    >

      {
        reallyShouldShowSocialLinks &&
          <HeaderSocialLinks socialLinks={socialLinks }/>
      }

      <HeaderContents 
        isInPageSearchEnabled={isInPageSearchEnabled && !renderAsMobile}
        pageTitle={pageTitle} 
        secondaryLogoData={secondaryLogoData}
        shouldShowTitle={shouldShowTitle}
        shouldShowLanguageSelectorInHeader={shouldShowLanguageSelectorInHeader}
        appliedLanguages={appliedLanguages}
        currentLanguageIso={currentLanguageIso}
        defaultLanguageIso={defaultLanguageIso}
        onLanguageChange={onLanguageChange}
        onHeaderLogoClick={onHeaderLogoClick}
        onSearchStarterClick={onSearchStarterClick}
      />

      {children}

    </HeaderWrapperUi>
  );
};

export default HeaderUi;
